Fastweb.Matches = (function($) {

  init = function(current_filter) {
    $('#matches_tabs').foundation('selectTab', $('#' + current_filter), true);
  }

  goToSelectedTab = function() {
  	href = window.location.href;
    current_tab = href.split('#')[1];
    if ( current_tab ) {
      document.cookie = 'matches_tab=' + current_tab;
      $(document).ready(function(){
        $("#" + current_tab + "-label").click();
      });
    }
  }

  sortMatches = function(fetch_path, current_filter) {
    $.ajax({
      'url': fetch_path,
      'data': {"current_filter": current_filter, "order": $('#drop_sort').val(), "page": 1},
      'dataType': 'script'
    });
  }


  return {init: init, goToSelectedTab: goToSelectedTab, sortMatches: sortMatches}

})(jQuery);
